/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { TemplateRef } from '@angular/core';

export class ModalConfig {
  identifier?: string;
  contentType?: string;
  content?: string | TemplateRef<any>;

  disableHeaderCloseBtn?: boolean;
  headerContent?: string;
  showAlertIcon?: boolean;
  noButtonLabel?: string;
  yesButtonLabel?: string;
  isDecisionModal?: boolean;
  enableYesBtn?: boolean;
  disableNoBtn?: boolean;
  isScanDoc?: boolean;
  showChkBox?: boolean;
  chkBoxValue?;
  chkBoxTxt?: string;
  data?: any;
  modalClass?: string;
  isBlockModal?: boolean;
  showUri?: boolean;
  uri?: string;
  result?: any;
}
